import type { MarkerItem } from './types'

export type LocationUrlConfig = {
  redirectBaseUrl: string
  microchurchSlug: string
}

export function getLocationUrl(
  location: Pick<MarkerItem, 'status' | 'slug'>,
  config: LocationUrlConfig
): string {
  if (location.status === 'microchurch' && location.slug) {
    return `${config.redirectBaseUrl}/${config.microchurchSlug}/${location.slug}`
  }
  return `${config.redirectBaseUrl}/${location.slug}`
}
